<template>
  <div :class="`${rowClass} h-100`">
    <div :class="`${colClass} h-100`">
      <div :class="`card package ${block.text ? 'h-100' : ''}`">
        <div class="text-center">
          <video-wrapper :video="video" :block="block" :alone-in-card="!block.text" :organization="organization"></video-wrapper>
        </div>
        <div v-if="block.text" class="card-body pt-2">
          <div v-html="block.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VideoWrapper from './../microsite/VideoWrapper'

  export default {
    props: {
      block: Object,
      organization: Object,
    },
    components: {
      VideoWrapper,
    },
    computed: {
      video() {
        return {
          id: this.block.id,
          image_url: this.block.image_url,
          video_url: this.block.image_cta_url,
        }
      },
      rowClass() {
        return this.block.span_row ? _.getRowClass(this.block) : null
      },
      colClass() {
        return this.block.span_row ? _.getColClass(this.block) : null
      },
    },
  }
</script>
